/**
 * Created by Mark on 24/04/2017.
 */


import React from "react";
import {Tabs , Tab } from 'react-bootstrap'
import contentService from '../../../../services/content-service';
import Translations from '../../../../store/internationalization-store'
import exams from '../../../../classes/exams.js'

class VocabsPanel extends React.Component {

    constructor(props) {
        super();

        this.props = props;
        this.initalComment = false;
        this.feedback = {};
        this.slice = 0;
        this.state = {
            stuff:false,
            contentData:[],
            tabTitle:[]
        }
        this.gameLists = [];
        this.finalTasks = [];
    }

    getVocabData(uid, ietf, id, translation){
        contentService.getExamTranslation(uid, ietf).then(function(data) {
            var contentData = this.state.contentData;
            contentData[id] = data;
            var tabTitle = this.state.tabTitle;
            tabTitle[id] = translation;
            this.setState({selectedType:"exams", contentData:contentData, tabTitle:tabTitle});
        }.bind(this))
    }


    componentDidMount(){
        this.finalTasks = [];
        this.gameLists = [];
        var tasks = this.props.data.homework.tasks;
        var counter = 0;
        var catalogList = [];
        for (var i = 0; i < this.props.data.homework.tasks.length; i++) {
            if (tasks[i].feature_uid == 5) {
                if (!catalogList.includes(tasks[i].rel_module_uid)) {
                    catalogList.push(tasks[i].rel_module_uid)
                    this.getVocabData(tasks[i].rel_module_uid,this.props.data.homework.languageCode, 
                        counter,Translations.getModuleNoIndexTranslation(tasks[i].module_translation));
                    this.finalTasks.push(tasks[i]);
                    counter++;
                }
                if (this.gameLists[tasks[i].rel_module_uid] == undefined) {
                    this.gameLists[tasks[i].rel_module_uid] = [];
                }
                this.gameLists[tasks[i].rel_module_uid].push([tasks[i].game_uid, tasks[i].gameTitle]);
            }
        }
    }

    buildTab(data, j) {
        var tabs = [];
        for (var i= 0; i < this.gameLists[data.rel_module_uid].length; i++) {
            var examsObject = 
                    new exams(this.state.contentData[j]).generateData(this.gameLists[data.rel_module_uid][i][0]);
            var mainText = examsObject[0];
            var questions = examsObject[1];
            tabs.push(<Tab eventKey={"SubTab"+i} title={Translations.get(this.gameLists[data.rel_module_uid][i][1], "game")}>
                 <div>
                            {mainText}
                            {questions}
                </div>
            </Tab>)
        }
        return tabs;
    }

    generateTabs() {
        var tabs = [];
        for (var i= 0; i < this.finalTasks.length; i++) {
            var examsObject = new exams(this.state.contentData[i]).generateData(this.finalTasks[i].game_uid);
            var mainText = examsObject[0];
            var questions = examsObject[1];
            var tabData = this.buildTab(this.finalTasks[i], i);
            tabs.push(<Tab eventKey={"vocabTab"+i} title={this.state.tabTitle[i]}>
                 <div>
                 <Tabs
                    id="controlled-tab-example"
                    activeKey={this.state.key2}
                    onSelect={key2 => this.setState({ key2 })}
                    style={{marginBottom:"0px", marginLeft:"0px"}}>
                    {tabData}
                </Tabs>
                    
                </div>
            </Tab>)
        }
        return tabs;
    }


    render(){
        if (this.state.contentData.length != this.finalTasks.length) {
            return "";
        }
        return <div style={{paddingTop:"10px"}} className="pmbb-body">
            <Tabs
                id="controlled-tab-example"
                activeKey={this.state.key}
                onSelect={key => this.setState({ key })}
                style={{marginBottom:"0px", marginLeft:"0px"}}>
                {this.generateTabs()}
            </Tabs>
            
        </div>;
    }
}




export default {
    name: function() {return <span>{Translations.get(12042 ,'Exam Skills')}</span>} ,
    component: VocabsPanel
}